import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { Icon, Row, Col } from 'antd'


class SSider extends Component {
  componentWillMount() {
  }
  getMenuItemClass = (activePath = '') => {
    const { query } = this.props
    const queryPathName = query.sider ? query.sider : ''
    const pathname = location.pathname
    if (activePath.indexOf(pathname) > -1 || (queryPathName && activePath.indexOf(queryPathName) > -1)) {
      return 'menu-item active'
    }
    else return 'menu-item'
  }
  render() {
    const { query, user } = this.props
    const userMenusArr = user.userMenus ? Object.keys(user.userMenus) : []
    const siderList = user.userMenus['工作流程']
    return userMenusArr.includes('工作流程') ? (
      <div className="l-sider-w">
        <ul className="menu-root">
          {
            siderList.map((rootItem) => {
              return (
                <li className={this.getMenuItemClass(rootItem.url)} key={rootItem.id}>
                  <div className="menu-submenu-title">
                    <span className="icon-w"><Icon type={rootItem.icon} /></span>
                    {
                      rootItem.url ? <a href={rootItem.url} className="item-link">{rootItem.moduleName}</a> : rootItem.moduleName
                    }
                  </div>
                  {
                    rootItem.subModules && rootItem.subModules.length > 0 ? (
                      <ul className="menu-sub">
                        {
                          rootItem.subModules.map((subItem) => {
                            return (
                              <li className={this.getMenuItemClass(subItem.url)} key={subItem.id}>
                                <a href={subItem.url} className="link">{subItem.moduleName}</a>
                              </li>
                            )
                          })
                        }

                      </ul>
                    ) : null
                  }
                </li>

              )
            })
          }
        </ul>
      </div>
    ) : null
  }
}


const mapStateToProps = ({ query, user }) => {
  return {
    query,
    user
  }
}

export default connect(mapStateToProps)(SSider)


// WEBPACK FOOTER //
// ./src/components/workflow/sider.js